// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-wrapper .mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}
.section-wrapper .justify-end {
  justify-content: end;
}
.section-wrapper {
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
}
.section-wrapper .mat-card-header-text {
  height: auto;
  width: 0px;
  margin: 0px;
}
.section-wrapper .mat-mdc-card-header .mat-mdc-card-title {
  font-size: 24px !important;
}
.section-wrapper .mat-mdc-card-subtitle {
  font-size: 22px !important;
}
.section-wrapper .pointer {
  cursor: pointer;
}
.section-wrapper .sort {
  width: 180px;
}
.section-wrapper .wide50px {
  width: 50px;
}
.section-wrapper .hide {
  display: none;
}
.section-wrapper .show {
  display: block;
}
.section-wrapper .mat-mdc-card-header {
  background-color: #2B95CA !important;
  padding: 5px !important;
}
.section-wrapper .mat-mdc-card {
  padding: 0 !important;
}
.section-wrapper .mat-mdc-card-content {
  padding: 5px !important;
}
.section-wrapper .add_question_btn {
  margin-right: 15px !important;
  margin-bottom: 15px !important;
}
.section-wrapper .expand {
  flex-grow: 2;
}
.section-wrapper .center {
  text-align: center;
}
.section-wrapper .section_text {
  color: #000 !important;
}
.section-wrapper .section-heading {
  margin: 0;
  padding: 0;
  width: 100%;
}
.section-wrapper .section-header-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: inherit;
  font-family: inherit;
}
.section-wrapper .section-header-button:focus {
  outline: 2px solid #005fcc;
  outline-offset: 2px;
}
.section-wrapper .section-header-button:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.section-wrapper .section-header-button .mat-mdc-card-title,
.section-wrapper .section-header-button .mat-mdc-card-subtitle {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/ng-formly/Wrappers/page-wrapper.component.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,YAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;AANA;EASE,2HAAA;AAAF;AACE;EACE,YAAA;EACA,UAAA;EACA,WAAA;AACJ;AAEE;EACE,0BAAA;AAAJ;AAGE;EACE,0BAAA;AADJ;AAGE;EACE,eAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,oCAAA;EACA,uBAAA;AANJ;AASE;EACE,qBAAA;AAPJ;AAUE;EACE,uBAAA;AARJ;AAWE;EACE,6BAAA;EACA,8BAAA;AATJ;AAYE;EACE,YAAA;AAVJ;AAaE;EACE,kBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;AAeE;EACE,SAAA;EACA,UAAA;EACA,WAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AAdJ;AAgBI;EACE,0BAAA;EACA,mBAAA;AAdN;AAiBI;EACE,qCAAA;AAfN;AAkBI;;EAEE,oBAAA;AAhBN","sourcesContent":[".section-wrapper {\r\n  .mat-mdc-raised-button.mat-blue {\r\n    background-color: #5479b9;\r\n    color: white;\r\n  }\r\n\r\n  .justify-end {\r\n    justify-content: end;\r\n  }\r\n  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\n  .mat-card-header-text {\r\n    height: auto;\r\n    width: 0px;\r\n    margin: 0px;\r\n  }\r\n\r\n  .mat-mdc-card-header .mat-mdc-card-title {\r\n    font-size: 24px !important;\r\n  }\r\n\r\n  .mat-mdc-card-subtitle {\r\n    font-size: 22px !important;\r\n  }\r\n  .pointer {\r\n    cursor: pointer;\r\n  }\r\n\r\n  .sort {\r\n    width: 180px;\r\n  }\r\n\r\n  .wide50px {\r\n    width: 50px;\r\n  }\r\n\r\n  .hide {\r\n    display: none;\r\n  }\r\n\r\n  .show {\r\n    display: block;\r\n  }\r\n\r\n  .mat-mdc-card-header {\r\n    background-color: #2B95CA !important;\r\n    padding: 5px !important;\r\n  }\r\n\r\n  .mat-mdc-card {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .mat-mdc-card-content {\r\n    padding: 5px !important;\r\n  }\r\n\r\n  .add_question_btn {\r\n    margin-right: 15px !important;\r\n    margin-bottom: 15px !important;\r\n  }\r\n\r\n  .expand {\r\n    flex-grow: 2;\r\n  }\r\n\r\n  .center {\r\n    text-align: center;\r\n  }\r\n\r\n  .section_text {\r\n    color: #000 !important;\r\n  }\r\n\r\n  .section-heading {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .section-header-button {\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    cursor: pointer;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n    text-align: inherit;\r\n    font-family: inherit;\r\n\r\n    &:focus {\r\n      outline: 2px solid #005fcc;\r\n      outline-offset: 2px;\r\n    }\r\n\r\n    &:hover {\r\n      background-color: rgba(0, 0, 0, 0.04);\r\n    }\r\n\r\n    .mat-mdc-card-title,\r\n    .mat-mdc-card-subtitle {\r\n      pointer-events: none; // Prevent nested click events\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
